<template>
  <div class="main-space">
    <GuidesContainer :items="items" :title="title" :subtitle="subtitle" @view="handleView" @click="handleClick" />
  </div>
</template>

<script setup lang="ts">
import { GuidesContainer } from '@experience/guides-container';

import { useAnalytics } from '@/shared/lib/analytics';
import { type GuideSlide } from '@/shared/models/guide';

defineProps<{
  items: GuideSlide[];
  title: string;
  subtitle: string;
}>();

const { trackEvent, trackEventImmediately } = useAnalytics();

const handleView = () => {
  void trackEvent('main:guides:guide.view');
};

const handleClick = (params: { position: number; guide_id: number }) => {
  void trackEventImmediately('main:guides:guide.click', params);
};
</script>
